
//add this product-modal to /index.js:  import "./js/product-modal.js";


import "js/vendors/slick.js";
import "js/vendors/jquery.magnific-popup.custom";


export function setupProductModal(){
 F20.setupProductModal();
}

var F20 = window.F20 || {};
F20.settings = F20.settings || {};

F20 = {
  "breakpoint": 768, // tablet is the same as desktop
}

/*

&zone0=ShashkaIS_1
&zone1=ShashkaIS_2
&zone2=ShashkaIS_3
&zone3=SentinelIS_1
&zone4=SentinelIS_2
&zone5=SentinelIS_3
&zone6=SentinelAR_1
&zone7=SentinelAR_2
&zone8=SentinelAR_3
&zone9=SentinelAR_4
&zone10=SentinelAR_5
&zone11=SentinelLT_1
&zone12=SentinelLT_2
&zone13=SentinelLT_3
&zone14=SentinelLT_4
&zone15=Incendia_1
&zone16=Incendia_2
&zone17=Incendia_3
&zone18=Incendia_4
&zone19=Andessa_1
&zone20=Andessa_2
&zone21=Andessa_3
&zone22=Ravenna_1
&zone23=Ravenna_2
&zone24=Ravenna_3
&zone25=RavennaLT_1
&zone26=RavennaLT_2
&zone27=RavennaLT_3
&zone28=RavennaLT_4
&zone29=RavennaLT_5
&zone30=RushIS_1


&zone31=RushIS_2
***RENAMED***
&zone31=RushIS2

&zone32=RushIS_3
&zone33=RushIS_4
&zone34=Rush_1
&zone35=Rush_2
&zone36=Rush_3
&zone37=Rush_4
&zone38=Rush_5
&zone39=SabreAR_1
&zone40=SabreAR_2
&zone41=SabreAR_3
&zone42=SabreAR_4
&zone43=SabreAR_5
&zone44=SabreLT_1
&zone45=SabreLT_2
&zone46=SabreLT_3
&zone47=SabreLT_4
&zone48=Macai_1
&zone49=Macai_2
&zone50=Macai_3
&zone51=Macai_4
&zone52=Cassiar_1
&zone53=Cassiar_2
&zone54=Cassiar_3
&zone55=CassiarLT_1
&zone56=CassiarLT_2
&zone57=CassiarLT_3
&zone58=CassiarLT_4
&zone59=CassiarLT_5

*/


F20.settings = {

 'siteId':'2cddd73a-34cf-4976-bb5c-fe99dc63747c',
 'zone':'&zone0=ShashkaIS_1&zone1=ShashkaIS_2&zone2=ShashkaIS_3&zone3=SentinelIS_1&zone4=SentinelIS_2&zone5=SentinelIS_3&zone6=SentinelAR_1&zone7=SentinelAR_2&zone8=SentinelAR_3&zone9=SentinelAR_4&zone10=SentinelAR_5&zone11=SentinelLT_1&zone12=SentinelLT_2&zone13=SentinelLT_3&zone14=SentinelLT_4&zone15=Incendia_1&zone16=Incendia_2&zone17=Incendia_3&zone18=Incendia_4&zone19=Andessa_1&zone20=Andessa_2&zone21=Andessa_3&zone22=Ravenna_1&zone23=Ravenna_2&zone24=Ravenna_3&zone25=RavennaLT_1&zone26=RavennaLT_2&zone27=RavennaLT_3&zone28=RavennaLT_4&zone29=RavennaLT_5&zone30=RushIS_1&zone31=RushIS2&zone32=RushIS_3&zone33=RushIS_4&zone34=Rush_1&zone35=Rush_2&zone36=Rush_3&zone37=Rush_4&zone38=Rush_5&zone39=SabreAR_1&zone40=SabreAR_2&zone41=SabreAR_3&zone42=SabreAR_4&zone43=SabreAR_5&zone44=SabreLT_1&zone45=SabreLT_2&zone46=SabreLT_3&zone47=SabreLT_4&zone48=Macai_1&zone49=Macai_2&zone50=Macai_3&zone51=Macai_4&zone52=Cassiar_1&zone53=Cassiar_2&zone54=Cassiar_3&zone55=CassiarLT_1&zone56=CassiarLT_2&zone57=CassiarLT_3&zone58=CassiarLT_4&zone59=CassiarLT_5',//this one can be multiple,  zone0= &zone1=
 //'zone':'zone0=GammaHike_3',
 'region':ARCTERYX.WEBSITE_SETTINGS.COUNTRY,
 'currency':false,
 'fields':'name%2Cprices%2Cimages%2Calt_image%2Crating%2Creview_count%2Cgender%2CFSM_CategoryTitles%2Curl%2Csubname%2Cshortdescription%2CFSM_Color%2CFSM_Color_With_Regions%2Ccolor%2CbaseColor%2Cweight%2Csize%2Cnew%2Ctoprated%2Crevised',
 'language':ARCTERYX.WEBSITE_SETTINGS.LANG.toLocaleLowerCase(),
 'config_warehouse':'VAN',//default
 'config_region':ARCTERYX.WEBSITE_SETTINGS.COUNTRY,
 'config_categorytree':'WEBCAT',
 'config_gender':'MALE%2CFEMALE%2CNEUTRAL',
 'isDevice': false,
};



async function getWarehouse(country) {
  return await fetch(`https://arcteryx.com/${country}/en/api/warehouseconfig/`)
    .then(resp => resp.json())
    .catch(e => {
      console.error("Error retrieving data from Warehouse API"); // eslint-disable-line no-console
      console.error(e.message); // eslint-disable-line no-console
    });
}

async function init() {
  const warehouse = await getWarehouse(ARCTERYX.WEBSITE_SETTINGS.COUNTRY.toLowerCase());

  //const warehouse = await getWarehouse('ca');
  /*
  const zones = ARCTERYX.WEBSITE_SETTINGS.ATTRAQT_ZONE.split(",");
  const customerPromise = getCustomer();
  const attraqtPromise = getAttraqtData(
    ARCTERYX.WEBSITE_SETTINGS.MARKET,
    ARCTERYX.WEBSITE_SETTINGS.SEASON,
    ARCTERYX.WEBSITE_SETTINGS.COUNTRY,
    ARCTERYX.WEBSITE_SETTINGS.LANG,
    {
      apiUrl: ARCTERYX.WEBSITE_SETTINGS.ATTRAQT_URL,
      zones,
      warehouse,
      gender: [ARCTERYX.WEBSITE_SETTINGS.ATTRAQT_GENDER]
    }
  );
  Promise.all([attraqtPromise, customerPromise]).then(values => {
    const [attraqtResponse, customer] = values;
    renderProducts(attraqtResponse, customer);
  });
  */
  console.log('warehouse=',warehouse);
  F20.settings.config_warehouse = warehouse;



  const url = `https://attraqt.arcteryx.com/zones-ajax.aspx?siteId=${ F20.settings.siteId }&${ F20.settings.zone }&region=${ F20.settings.region }&currency=${ F20.settings.currency }&fields=${ F20.settings.fields }&language=${ F20.settings.language }&config_warehouse=${ F20.settings.config_warehouse }&config_region=${ F20.settings.config_region }&config_categorytree=${ F20.settings.config_categorytree }&config_gender=${ F20.settings.config_gender }`;


  $.ajax( {
    url,
    "crossDomain": true,
    "success"( response ) {

      F20.products = [];
      console.log('response.zones.length',response.zones.length);

       for ( var i = 0; i < response.zones.length; i++ ) {
          //console.log('i',i,response.zones.length);
          const zone = response.zones[i];
      
      //console.log('zone',zone);
          if ( zone.status == "error" ) {
            console.error( `Error getting Attraqt zone: ${ zone.error}` );
          } else {

            if (typeof zone.data !== "undefined"){
            
              let products = zone.data.results;
           //console.log('products',products);
              let productsArray = [];
           //console.log(products.length);   

              for ( var j = 0; j < products.length; j++ ) {
             /*
              * If no prices, then data from Attraqt is invalid.
              * Do not continue otherwise JS errors will stop cart from loading properly.
              */
                if ( typeof products[j].fields.prices !== "undefined" ) {
               

              
                 //change to custom image put object values on different levels

                  var combinedObject = Object.assign({}, products[j].fields, products[j].custom);
                  

                  productsArray.push(combinedObject);
                }
              }

              //console.log(F20.products);
              F20.products[zone.zoneId] = productsArray;
              //F20.products = productsArray;
              console.log('F20.products['+zone.zoneId+']',F20.products[zone.zoneId]);
             
            }else{
              console.log("zone.data undefined",zone,zone.data);
            }

          }
        }

      
  
    },
    "error"() {
      console.error( "Error calling API" );
    },
  } );



}

init();





( function ( $ ) {

 
 F20.setupProductModal = function(){

  const deviceAgent = navigator.userAgent.toLowerCase();
  const matchDevice = ( deviceAgent.match( /(iphone|ipod|ipad)/ )
      || deviceAgent.match( /(android)/ )
      || deviceAgent.match( /(iemobile)/ )
      || deviceAgent.match( /iphone/i )
      || deviceAgent.match( /ipad/i )
      || deviceAgent.match( /ipod/i )
      || deviceAgent.match( /blackberry/i )
      || deviceAgent.match( /bada/i ) );

  F20.settings.isDevice = Boolean( matchDevice );
  
//console.log('hasclass desktop',$("body").hasClass("desktop"));  
  F20.settings.currency = F20.getCurrencyCode ( ARCTERYX.WEBSITE_SETTINGS.COUNTRY, false )

  $("body").on( "click", ".slick-slide .image", function(e) {
   
   if ($(this).hasClass("no-link")){
    //anything other than slick-current can be used to navigate if clicked on
    //two slideshows are only on mobile and only one on desktop with class '.slideshow'
    if ($("#mobile-sized").is(":visible") || $(this).parents(".slick-slider").hasClass("slideshow")){
     e.preventDefault();
    }
    //console.log("no link");
   }else{
    //console.log("follow link");
   }
  });


  //$(".rollover-tag").click(function (e) {
  //$(".rollover-tag .indicate-icon, .rollover-tag--slideshow .indicate-icon").click(function (e) {
  $(".rollover-tag--slideshow .rollover-alternate--slide").click(function(e){

    var $rolloverTag = $(this);

    var sectionId = $(this).parents('.section-container').attr("id");

    var productFeed = $rolloverTag.data("products").toString();

    F20.trackPropEvent("prop70", "eVar70", 'tagClick:' + sectionId + ':' + $rolloverTag.data("panel") + ' product:'+productFeed);



    if (productFeed){
    //console.log('rollover tag slideshow  F20.openProductView');
    F20.openProductView(productFeed);
    }

    return false;

  })



  $(".rollover-no-tag, .rollover-alternate").not(".rollover-alternate--slide").click(function (e) {
    //e.stopPropagation();

   var $rolloverTag = $(this);

   var sectionId = $(this).parents('.section-container').attr("id");

   var productFeed = $rolloverTag.data("products").toString();

   F20.trackPropEvent("prop70", "eVar70", 'nonTagClick:' + sectionId + ':' + $rolloverTag.data("panel") + ' product:'+productFeed);




   if (productFeed){
    console.log('rollover tag  F20.openProductView');
    F20.openProductView(productFeed);
   }

   return false;
  })
  




  
  //}

  //const url = 'https://esp-uat.locayta.com/zones-ajax.aspx?siteId=2cddd73a-34cf-4976-bb5c-fe99dc63747c&zone0=CDP_Main_Product_Grid&region=CA&currency=CA_CAD&fields=name%2Cprices%2Cimages%2Calt_image%2Crating%2Creview_count%2Cgender%2CFSM_CategoryTitles%2Curl%2Csubname%2Cshortdescription%2CFSM_Color%2CFSM_Color_With_Regions%2Ccolor%2CbaseColor%2Cweight%2Csize%2Cnew%2Ctoprated%2Crevised&language=en&config_warehouse=ROCK&config_region=CA&config_categorytree=WEBCAT&config_gender=MALE%2CFEMALE%2CNEUTRAL';


  //https://attraqt.arcteryx.com/zones-ajax.aspx?siteId=7c5bf23e-839a-4e8c-938c-a0401ac483f4&region=CA&currency=CA_CAD&fields=name%2Cprices%2Cimages%2Calt_image%2Crating%2Creview_count%2Cgender%2CFSM_CategoryTitles%2Curl%2Csubname%2Cshortdescription%2CFSM_Color%2CFSM_Color_With_Regions%2Ccolor%2CbaseColor%2Cweight%2Csize%2Cnew%2Ctoprated%2Crevised&language=en&config_region=CAshortdescription%2CFSM_Color%2CFSM_Color_With_Regions%2CFSM_Attrimages%2Ccolor%2CbaseColor%2Cweight%2Csize%2Cnew%2Ctoprated%2Crevised&config_gender=MALE,NEUTRAL&zone0=LBClimb1_Mens&zone1=LBEveryday2_Mens&zone2=LBHike1_Mens



/*
  setTimeout(function(){

   console.log('F20.products',F20.products,F20.products['Norvan_LD2'],F20.products['Nuclei_Climb']);
   //F20.openProductView('Nuclei_Climb');
   F20.openProductView('Norvan_LD2');
   
  },5000);
*/

 };
 
 F20.getCurrencyCode = function ( countryCode, currencyOnly ) {
  switch ( countryCode.toUpperCase() ) {
    case "US":
   if ( currencyOnly ) {
     return "USD";
   }
   return "US_USD";
    case "CA":
   if ( currencyOnly ) {
     return "CAD";
   }
   return "CA_CAD";
    case "DE":
   if ( currencyOnly ) {
     return "EUR";
   }
   return "DE_EUR";
    case "GB":
   if ( currencyOnly ) {
     return "GBP";
   }
   return "GB_GBP";
    case "PL":
   if ( currencyOnly ) {
     return "PLN";
   }
   return "PL_PLN";
    case "DK":
   if ( currencyOnly ) {
     return "DKK";
   }
   return "DK_DKK";
    case "NO":
   if ( currencyOnly ) {
     return "NOK";
   }
   return "NO_NOK";
    case "SE":
   if ( currencyOnly ) {
     return "SEK";
   }
   return "SE_SEK";
    case "AT":
   if ( currencyOnly ) {
     return "EUR";
   }
   return "AT_EUR";
    case "BE":
   if ( currencyOnly ) {
     return "EUR";
   }
   return "BE_EUR";
    case "CH":
   if ( currencyOnly ) {
     return "CHF";
   }
   return "CH_CHF";
    case "CZ":
   if ( currencyOnly ) {
     return "EUR";
   }
   return "CZ_EUR";
    case "ES":
   if ( currencyOnly ) {
     return "EUR";
   }
   return "ES_EUR";
    case "FI":
   if ( currencyOnly ) {
     return "EUR";
   }
   return "FI_EUR";
    case "FR":
   if ( currencyOnly ) {
     return "EUR";
   }
   return "FR_EUR";
    case "IE":
   if ( currencyOnly ) {
     return "EUR";
   }
   return "IE_EUR";
    case "IT":
   if ( currencyOnly ) {
     return "EUR";
   }
   return "IT_EUR";
    case "JP":
   if ( currencyOnly ) {
     return "JPY";
   }
   return "JP_JPY";
    case "CN":
   if ( currencyOnly ) {
     return "CNY";
   }
   return "CN_CNY";
    case "NL":
   if ( currencyOnly ) {
     return "EUR";
   }
   return "NL_EUR";
    default:
   if ( currencyOnly ) {
     return "CAD";
   }
   return "CA-CAD";
  };
 };
  
 F20.trackPropEvent = function( prop, eVar, eventString ) {
    const propObject = {};
    const eVarObject = {};
 
    propObject[prop] = eventString;
    eVarObject[eVar] = eventString;

    eVarObject['eVar3'] = window.location.href;
 
    console.log('propObject', propObject);
    console.log('eVarObject', eVarObject);
     
 
    ARCTERYX.analytics.trackEvent( {
	  "category": "f20-winter-lookbook",
	  "action": "",
	  "label": eventString,
	  "props": propObject,
	  "eVars": eVarObject,
    } );
 };



 //from shop-attraqt.js
 F20.getProductImage = function ( images, forCart ) {
  if ( images.length ) {
   let returnImage = images[images.length - 1];
   const imagesReverse = images.reverse();
   let i = 0;

   // Ensure it returns the last 350w image from the array
   for ( i = 0; i < imagesReverse.length; i++ ) {
   if ( imagesReverse[i].match( "350w" ) ) {
    returnImage = imagesReverse[i];
    break;
   }
   }

   if ( forCart ) {
   // Ensure it returns the last 162x205 image from the array
   for ( i = 0; i < imagesReverse.length; i++ ) {
    if ( imagesReverse[i].match( "162x205" ) ) {
    returnImage = imagesReverse[i];
    break;
    }
   }
   }

   return returnImage
   .replace( "-SAMPLE--", "" )
   .replace( "JAPAN-ONLY---CAYENNE", "Cayenne" )
   .replace( "JAPAN-ONLY---BLACK", "Black" ); // FE workaround for PDP17-1411
  }
  return null;
 };
 /*
 * Returns Array of alternate colour items
 */
 //from shop-attraqt.js. slightly modified
 F20.setProductAltColours = function ( productName, altColourArr, imageUrl ) {
  const productAltColors = [];
  let colorItem;
  for ( let a = 0; a < altColourArr.length; a++ ) {
  // Only add colour if it is NOT restricted for the country
  if ( altColourArr[a].indexOf( `:${ ARCTERYX.WEBSITE_SETTINGS.COUNTRY };false` ) < 0 ) {
   const colourExclusion = new RegExp( ":[A-Z]{2};false", "g" );
   const colorName = altColourArr[a].split( ":" )[0];
   const baseColor = altColourArr[a].replace( colourExclusion, "" )
   .split( ":" )[1].toLowerCase()
   .replace( "/", "-" );
   const colorNameWithdashes = colorName.replace( /\/\s/g, "/" )
   .replace( /\//g, "-" )
   .replace( /\s/g, "-" );
   colorItem = {
   "colorProductName": productName,
    colorName,
    baseColor,
   "colorNameWithDashes": colorNameWithdashes,
   "altColorImage": `https://images.arcteryx.com/F20/50x75/${ productName }-${ colorNameWithdashes }.gif`,
   "mainImage": `https://images.arcteryx.com/F20/350w/${ productName }-${ colorNameWithdashes }.jpg`,
   };
   if ( imageUrl.match( colorNameWithdashes ) ) {
    productAltColors.unshift( colorItem );
   } else {
    productAltColors.push( colorItem );
   }
  }
  }
  return productAltColors;
 };






 F20.openProductView = function (attraqtId) {//productArray, merchArray, isPopup 
  let html = "";
  //if ( merchArray ) {
   html = F20.returnProductView(attraqtId);//productArray, merchArray, isPopup 
  //}

  //if ( isPopup ) {
   $.magnificPopup.open( {
  "items": {
   "src": html,
   "type": "inline",
   },
  "removalDelay": 600,
  "showCloseBtn": false,
  "callbacks": {
   "open"() {
    setTimeout( () => {
     $( ".product-container" )
     .addClass( "fade-in" );
    }, 200 );
    },
   "beforeClose"() {
    // SetTimeout(function(){
    $( ".product-container" )
     .removeClass( "fade-in" );
    // },1000)
    },
   },
   } );

  //} else {
  // $that.append( html );
  //}
 
 
  $( ".swatch" )
   .click( function () {
   const index = $( this )
    .index();
   $( this )
    .parent()
    .find( ".swatch" )
    .removeClass( "selected" );
   $( this )
    .addClass( "selected" );
 
   $( this )
    .parent()
    .parent()
    .parent()
    .find( ".product-images .image" )
    .removeClass( "selected" );
   $( this )
    .parent()
    .parent()
    .parent()
    .find( ".product-images .image" )
    .eq( index )
    .addClass( "selected" );
   } );
 
 
  
   $( ".slideshow" )
   .on( "init", slick => {
    // Slideshow set to infinite so starting image is not .eq(0)
    $( slick.currentTarget )
    .find( ".slick-current" )
    .find( ".image" )
    .removeClass( "no-link" );
    //console.log( ".slideshow init" );
   } );
 
   $( ".slideshow" )
   .slick( {
   "slidesToShow": 1,
   "slidesToScroll": 1,
   "infinite": true,
   "dots": false,
   "arrows": false,
   "centerMode": true,
   "centerPadding": "26%",
   "focusOnSelect": true,
   "speed": 200,
   } )
   .on( "afterChange", ( slick, slide ) => {
    slide.$slides.find( ".image" )
    .addClass( "no-link" );


    slide.$slides.eq( slide.currentSlide )
    .find( ".image" )
    .removeClass( "no-link" );
   } );
  
 };
 

 F20.getLocalePrice = function ( hasDigitalData, price ) {
  let defaultLocale = null;
 
  if ( hasDigitalData ) {
    defaultLocale = digitalData.websiteSettings.defaultCulture;
  }
 
  if ( $( "body" )
    .hasClass( "CART" ) ) {
    // Since Cart page currently not using Locale for currency format, match it for product recommendation pricing
    defaultLocale = ARCTERYX.helpers.countryCodeToLocale( "CA" );
  } else if ( hasDigitalData && ( defaultLocale === null || defaultLocale == "" || digitalData.websiteSettings.country == "SE" ) ) {
    defaultLocale = ARCTERYX.helpers.countryCodeToLocale( digitalData.websiteSettings.country );
  } else if ( ! hasDigitalData ) {
    defaultLocale = ARCTERYX.helpers.countryCodeToLocale( ARCTERYX.WEBSITE_SETTINGS.COUNTRY );
  }
 
  if ( ARCTERYX.WEBSITE_SETTINGS.COUNTRY === "JP" ) {
    return price.toLocaleString( defaultLocale, { "minimumFractionDigits": 0, "maximumFractionDigits": 0 } );
  }
 
  return price.toLocaleString( defaultLocale, { "minimumFractionDigits": 2, "maximumFractionDigits": 2 } );
 };


 F20.returnProductView = function (attraqtId) {// productArray, merchArray, isPopup 

  //let productListArray;
  let showCloseButton = true;
 
  var productListArray = [];

  
  
console.log("F20.products",F20.products);
 
 
  let slideshowClass = "slideshow";
 

  if ( F20.products[attraqtId].length < 2 ) {
   slideshowClass = "slideshow-single";

   // ShowCloseButton = false;
  }
 
 
  let html = "<div class=\"product-container\">";
 
 
  html += "<div class=\"action-image empty\"></div>";
  slideshowClass += " no-action-image";
 
 
  html += `<div class="transition-container"><div class="${slideshowClass }">`;
 
  //for ( let i = 0; i < productListArray.length; i++ ) {
  F20.products[attraqtId].forEach((product,i) => {
   

   /*
   *MerchColour is not in this json file
   *var merchColour = product.merchColour;
   */
 
   var selectedClass;
   let j = 0;
   let k = 0;

   //let firstImage;
   //let hasFirstImage = false;
   
 
   let productDetailsTxt = "Product Details";
 
   if ( ARCTERYX.WEBSITE_SETTINGS.LANGUAGE == "FRENCH" ) {
   productDetailsTxt = "Voir les détails";
   } else if ( ARCTERYX.WEBSITE_SETTINGS.LANGUAGE == "GERMAN" ) {
   productDetailsTxt = "Siehe Genauere Angaben";
   } else if ( ARCTERYX.WEBSITE_SETTINGS.LANGUAGE == "NORWEGIAN" ) {
   productDetailsTxt = "Vis Detaljer";
   } else if ( ARCTERYX.WEBSITE_SETTINGS.LANGUAGE == "SPANISH" ) {
   productDetailsTxt = "Ver detalles";
   } else if ( ARCTERYX.WEBSITE_SETTINGS.LANGUAGE == "CHINESE" ) {
   productDetailsTxt = "了解更多";
   } else if ( ARCTERYX.WEBSITE_SETTINGS.LANGUAGE == "JAPANESE" ) {
   productDetailsTxt = "詳細を見る";
   }






/*
   try {
    hasFirstImage = true;
    //firstImage = product.colors[merchColour].ColorCd;
    firstImage = merchArray[i];
    //console.log('found merchColour');
   } catch (e) {
    //compiled.imageFileName = product.colors[firstColour].filename;
    hasFirstImage = false;
    console.log('Couldn\'t find data for merchColour:'+merchColour);
   }
 */
   
   if ( product ) {
    html += "<div class=\"slide\"><div class=\"slide-container\">";
  
    html += "<div class=\"product-images\">";
  
  
    //const jsonProductColors = product.colors;
    let jsonProductColors = [];
    
  
  
    
  
    let gender = "";
    let genderForId = "";
    let productName = "";
 
    if ( product.gender.value[0].toLowerCase() === "male" ) {
     gender = "mens/";
    } else if ( product.gender.value[0].toLowerCase() === "female" ) {
     gender = "womens/";
     genderForId = "-W";
    }
 
    productName = product.url.value + genderForId;
 
  
    //product.fields.productAltColors = [];
    if ( product.FSM_Color_With_Regions ) {
     jsonProductColors = F20.setProductAltColours( productName, product.FSM_Color_With_Regions.value, F20.getProductImage( product.images.value, false ) );
    } else if ( product.FSM_Color ) {
     jsonProductColors = F20.setProductAltColours( productName, product.FSM_Color.value, F20.getProductImage( product.images.value, false ) );
    }
    
    
     //product.fields.imageUrl = F20.getProductImage( product.images.value, false );
   
     //console.log(F20.getProductImage( product.images.value, false ));
   
      
    /*
    const defaultColourRegex = new RegExp( `${product.url.value[0] }-(.+).jpg` );
    if ( product.imageUrl.match( defaultColourRegex ) === null ) {
     product.defaultColour = product.imageUrl.match( defaultColourRegex );
    } else {
     product.defaultColour = product.imageUrl.match( defaultColourRegex )[1];
    }
      
    console.log('product.defaultColour',product.defaultColour);
    */
   
   
    console.log(productName,'jsonProductColors',jsonProductColors);

    
    const model = ARCTERYX.helpers.modelConversionForNewPDP( product.url.value[0] );
    const productUrl = `/${ ARCTERYX.WEBSITE_SETTINGS.COUNTRY.toLowerCase() }/${ ARCTERYX.WEBSITE_SETTINGS.LANG.toLowerCase() }/shop/${ gender }${model}`;
    
    

    var defaultProductImage;
    var useDefaultProductImage = true;
    try {
     defaultProductImage = product.tags[F20.settings.config_warehouse].jpg;
    } catch (e) {
     //compiled.imageFileName = product.colors[firstColour].filename;
     useDefaultProductImage = false;
     console.log('Couldn\'t find data for default img tags.'+F20.settings.config_warehouse+'.jpg');
    }
    




     jsonProductColors.forEach((productColor,i) => {






/* hardcoded ID's for where "WEB EXCLUSIVE" tags have to apply that are not in the feed */

//console.log('ARCTERYX.WEBSITE_SETTINGS.COUNTRY',ARCTERYX.WEBSITE_SETTINGS.COUNTRY);


//console.log('product.id',product.id.value[0],productColor.colorName);

var onlineExclusiveTag = '';

if ( (product.id.value[0] == "27930"  && productColor.colorName == "Black Heather") ||  
(product.id.value[0] == "27930"  && productColor.colorName == "White") ||  
(product.id.value[0] == "24474"  && productColor.colorName == "SMU-Exosphere") ||  
(product.id.value[0] == "24477"  && productColor.colorName == "SMU-Exosphere") ||  
(product.id.value[0] == "26439"  && productColor.colorName == "SMU-24k Black") ||  
(product.id.value[0] == "27927"  && productColor.colorName == "Black Heather") ||  
(product.id.value[0] == "27927"  && productColor.colorName == "Hubble Heather") ||  
(product.id.value[0] == "27927"  && productColor.colorName == "White") ||  
(product.id.value[0] == "27928"  && productColor.colorName == "Paradigm") ||  
(product.id.value[0] == "27928"  && productColor.colorName == "Spiral") ||  
(product.id.value[0] == "27928"  && productColor.colorName == "White") ||  
(product.id.value[0] == "27932"  && productColor.colorName == "Black Heather") ||   
(product.id.value[0] == "27932"  && productColor.colorName == "Dynasty") ||  
(product.id.value[0] == "27932"  && productColor.colorName == "Spiral") ||  
(product.id.value[0] == "27932"  && productColor.colorName == "White") ||  
(product.id.value[0] == "27875"  && productColor.colorName == "SMU-Black" && ARCTERYX.WEBSITE_SETTINGS.COUNTRY == "CN") ||
(product.id.value[0] == "27875"  && productColor.colorName == "SMU-Aerocene" && ARCTERYX.WEBSITE_SETTINGS.COUNTRY == "CN") ||
(product.id.value[0] == "25166"  && productColor.colorName == "Stratosphere" && ARCTERYX.WEBSITE_SETTINGS.COUNTRY == "JP") ||
(product.id.value[0] == "25167"  && productColor.colorName == "Paradigm" && ARCTERYX.WEBSITE_SETTINGS.COUNTRY == "JP") ||
(product.id.value[0] == "27931"  && productColor.colorName == "Black Heather") ||  
(product.id.value[0] == "27931"  && productColor.colorName == "Dynasty") ||  
(product.id.value[0] == "27931"  && productColor.colorName == "Spiral") ||  
(product.id.value[0] == "27931"  && productColor.colorName == "White") ||  
(product.id.value[0] == "17307"  && productColor.colorName == "SMU-Dynasty" && ARCTERYX.WEBSITE_SETTINGS.COUNTRY == "CN") ||
(product.id.value[0] == "17307"  && productColor.colorName == "SMU-24k Black" && ARCTERYX.WEBSITE_SETTINGS.COUNTRY == "CN") ||
(product.id.value[0] == "26448"  && productColor.colorName == "SMU-Black") ||  
(product.id.value[0] == "27925"  && productColor.colorName == "Black Heather") ||  
(product.id.value[0] == "27925"  && productColor.colorName == "Dark Matter Heather") ||  
(product.id.value[0] == "27925"  && productColor.colorName == "White") ||  
(product.id.value[0] == "27926"  && productColor.colorName == "Stratosphere") ||  
(product.id.value[0] == "27926"  && productColor.colorName == "White") ||  
(product.id.value[0] == "26436"  && productColor.colorName == "SMU-Black Heather" && ARCTERYX.WEBSITE_SETTINGS.COUNTRY == "CN") ||
(product.id.value[0] == "23046"  && productColor.colorName == "SMU-Exosphere" && ARCTERYX.WEBSITE_SETTINGS.COUNTRY == "CN") ||
(product.id.value[0] == "7715"  && productColor.colorName == "SMU-24k Black" && ARCTERYX.WEBSITE_SETTINGS.COUNTRY == "CN") ||
(product.id.value[0] == "25234"  && productColor.colorName == "SMU-Black Heather" && ARCTERYX.WEBSITE_SETTINGS.COUNTRY == "CN") ||
(product.id.value[0] == "25169"  && productColor.colorName == "Hyperspace") ||  
(product.id.value[0] == "25170"  && productColor.colorName == "Paradigm") ||  
(product.id.value[0] == "25155"  && productColor.colorName == "SMU-Black" && ARCTERYX.WEBSITE_SETTINGS.COUNTRY == "CN") ||
(product.id.value[0] == "25171"  && productColor.colorName == "Labyrinth" && ARCTERYX.WEBSITE_SETTINGS.COUNTRY == "JP") ||
(product.id.value[0] == "25172"  && productColor.colorName == "Hyperspace" && ARCTERYX.WEBSITE_SETTINGS.COUNTRY == "JP") ||
(product.id.value[0] == "27929"  && productColor.colorName == "Black Heather") ){  
	//isOnlineExclusive = true;
	onlineExclusiveTag = `<img class="badge--exclusive" src="//images.arcteryx.com/cdp/badge/online-exclusive-EN.svg" alt="Online Exclusive">`;
	console.log('product.id exclusive',product.id.value[0],productColor.colorName);
}      





      var productImage = productColor.mainImage;

      if (useDefaultProductImage == false){
       defaultProductImage = productImage;
      }


      if (i == 0){
       html += `<div data-href="${ productUrl }" class="image no-link selected">`;
       
       html += onlineExclusiveTag;
       

       if (typeof(product.alt_image) != "undefined"){
       html += `<img class="hover" src="${ product.alt_image.value[0] }"/>`;
       }

       html += `<img src="${ defaultProductImage }"/>`;
       html += `</div>`;
      }

        //console.log("productImage,defaultProductImage",productImage,defaultProductImage);
        //console.log("productImage includes",!productImage.includes(defaultProductImage));
       if ( !productImage.includes(defaultProductImage)){
        //console.log("productImage", "inside if");
        html += `<div data-href="${ productUrl }" class="image no-link">`;
        
        html += onlineExclusiveTag;

        if (typeof(product.alt_image) != "undefined"){
        html += `<img class="hover" src="${ product.alt_image.value[0] }"/>`;
        }

        html += `<img src="${ productImage }"/>`;
        html += `</div>`;
       }
      
     });


/* used when setting specific color to feature   
     jsonProductColors.forEach(productColor => {
      //add first match
      var productImage = productColor.mainImage;
      if (productColor.colorName.includes(merchArray[i])){
       html += `<a href="${ productUrl }" class="image selected"><img src="${ productImage }"/></a>`;
      }
     });
     jsonProductColors.forEach(productColor => {
      //add everything else that doesn't match
      var productImage = productColor.mainImage;
      if (productColor.colorName.includes(merchArray[i]) === false){
       html += `<a href="${ productUrl }" class="image no-link"><img src="${ productImage }"/></a>`;
      }
     });
*/




     
   
     html += "</div>";
   
     html += "<div class=\"product-content\">";
   
   
     
     html += "<div class=\"color-picker\">";
   
   


    var defaultProductThumbnailImage;
    var useDefaultThumbnail = true;
    try {
     defaultProductThumbnailImage = product.tags[F20.settings.config_warehouse].gif;
     defaultProductThumbnailImage = defaultProductThumbnailImage.substring(defaultProductThumbnailImage.lastIndexOf('/')+1);
     //console.log("defaultProductThumbnailImage",defaultProductThumbnailImage.substring(defaultProductThumbnailImage.lastIndexOf('/')+1));
     defaultProductThumbnailImage = `https://images.arcteryx.com/F20/50x75/${ defaultProductThumbnailImage }`;
    } catch (e) {
     useDefaultThumbnail = false;     
     console.log('Couldn\'t find data for default thumb tags.'+F20.settings.config_warehouse+'.gif');
    }




     jsonProductColors.forEach((productColor,i) => {
      var thumbImage = productColor.altColorImage;

      
      if (useDefaultThumbnail == false){
       defaultProductThumbnailImage = thumbImage;
      }

      if (i == 0){
       html += `<div class="swatch selected" style="background-image:url(${ defaultProductThumbnailImage })"></div>`;
      }

       if ( !thumbImage.includes(defaultProductThumbnailImage) ){
       html += `<div class="swatch" style="background-image:url(${ thumbImage })"></div>`;
       }
      
     });
/*
     jsonProductColors.forEach(productColor => {
      //add first selected thumb image
      var thumbImage = productColor.altColorImage;
      if (productColor.colorName.includes(merchArray[i])){
       html += `<div class="swatch selected" style="background-image:url(${ thumbImage })"></div>`;
      }

     });


     jsonProductColors.forEach(productColor => {
      //add the rest of the non-selected images
      var thumbImage = productColor.altColorImage;
      if (productColor.colorName.includes(merchArray[i]) === false){
       html += `<div class="swatch" style="background-image:url(${ thumbImage })"></div>`;
      }

     });
     */
   
     html += "</div>";

   
     if ( product.new.value[0].toLowerCase() === "true" ) {
      if ( ARCTERYX.WEBSITE_SETTINGS.LANGUAGE == "GERMAN" ) {
      html += "<div class=\"revised\">Neu</div>";
      } else if ( ARCTERYX.WEBSITE_SETTINGS.LANGUAGE == "FRENCH" ) {
      html += "<div class=\"revised\">Nouveau</div>";
      } else if ( ARCTERYX.WEBSITE_SETTINGS.LANGUAGE == "NORWEGIAN" ) {
      html += "<div class=\"revised\">Ny</div>";
      } else if ( ARCTERYX.WEBSITE_SETTINGS.LANGUAGE == "SPANISH" ) {
      html += "<div class=\"revised\">Nuevo</div>";
      } else if ( ARCTERYX.WEBSITE_SETTINGS.LANGUAGE == "JAPANESE" ) {
      html += "<div class=\"revised\">新商品</div>";
      } else if ( ARCTERYX.WEBSITE_SETTINGS.LANGUAGE == "CHINESE" ) {
      html += "<div class=\"revised\">新款</div>";
      } else {
      html += "<div class=\"revised\">New</div>";
      }
     }
   
     if ( product.revised.value[0].toLowerCase() === "true" ) {
      if ( ARCTERYX.WEBSITE_SETTINGS.LANGUAGE == "GERMAN" ) {
      html += "<div class=\"revised\">Überarbeitet</div>";
      } else if ( ARCTERYX.WEBSITE_SETTINGS.LANGUAGE == "FRENCH" ) {
      html += "<div class=\"revised\">Revisité</div>";
      } else if ( ARCTERYX.WEBSITE_SETTINGS.LANGUAGE == "NORWEGIAN" ) {
      html += "<div class=\"revised\">Revidert utgave</div>";
      } else if ( ARCTERYX.WEBSITE_SETTINGS.LANGUAGE == "SPANISH" ) {
      html += "<div class=\"revised\">Mejorado</div>";
      } else if ( ARCTERYX.WEBSITE_SETTINGS.LANGUAGE == "JAPANESE" ) {
      html += "<div class=\"revised\">改良</div>";
      } else if ( ARCTERYX.WEBSITE_SETTINGS.LANGUAGE == "CHINESE" ) {
      html += "<div class=\"revised\">修改</div>";
      } else {
      html += "<div class=\"revised\">Revised</div>";
      }
     }
     /*
     if ( productListArray[productId].isNewColour == true ) {
      if ( ARCTERYX.WEBSITE_SETTINGS.LANGUAGE == "GERMAN" ) {
      html += "<div class=\"revised\">Neue Farbe</div>";
      } else if ( ARCTERYX.WEBSITE_SETTINGS.LANGUAGE == "FRENCH" ) {
      html += "<div class=\"revised\">Nouvelle couleur</div>";
      } else if ( ARCTERYX.WEBSITE_SETTINGS.LANGUAGE == "NORWEGIAN" ) {
      html += "<div class=\"revised\">Ny farge</div>";
      } else if ( ARCTERYX.WEBSITE_SETTINGS.LANGUAGE == "SPANISH" ) {
      html += "<div class=\"revised\">Nuevo color</div>";
      } else if ( ARCTERYX.WEBSITE_SETTINGS.LANGUAGE == "JAPANESE" ) {
      html += "<div class=\"revised\">新色</div>";
      } else if ( ARCTERYX.WEBSITE_SETTINGS.LANGUAGE == "CHINESE" ) {
      html += "<div class=\"revised\">新色调</div>";
      } else {
      html += "<div class=\"revised\">New Colour</div>";
      }
     }
     */
   
   
     html += `<div class="title">${ product.name.value[0] }</div>`;
     //html += `<div class="description">${ product.shortdescription.value[0] }</div>`;
     //even shorter version...:
     html += `<div class="description">${ product.subname.value[0] }</div>`;



    let currencySymbolRight = false;
    let currency = 'CAD';
    let currencySymbol = '$';


     if (typeof ARCTERYX.helpers.price != 'undefined' && typeof ARCTERYX.helpers.price.getPriceModel != 'undefined'){
    //this is the new price formatting which may or may not exist yet

      //console.log("ARCTERYX.helpers.price.getPriceModel undefined");
      currencySymbolRight = ARCTERYX.helpers.price.getPriceModel( ARCTERYX.WEBSITE_SETTINGS.COUNTRY ).currencySymbolRight;
      currency = ARCTERYX.helpers.price.getPriceModel( ARCTERYX.WEBSITE_SETTINGS.COUNTRY ).currency;
      currencySymbol = ARCTERYX.helpers.price.getPriceModel( ARCTERYX.WEBSITE_SETTINGS.COUNTRY ).currencySymbol;

     }else if (typeof ARCTERYX.helpers.priceDisplaySettings != 'undefined'){

      //console.log("ARCTERYX.helpers.priceDisplaySettings undefined");
      currencySymbolRight = ARCTERYX.helpers.priceDisplaySettings( ARCTERYX.WEBSITE_SETTINGS.COUNTRY ).currencySymbolRight;
      currency = ARCTERYX.helpers.priceDisplaySettings( ARCTERYX.WEBSITE_SETTINGS.COUNTRY ).currency;
      currencySymbol = ARCTERYX.helpers.priceDisplaySettings( ARCTERYX.WEBSITE_SETTINGS.COUNTRY ).currencySymbol;

     }else{
      console.log('no price display defined');
        
     }





     let price = F20.getLocalePrice( false, product.prices.value[0] );
     if ( ARCTERYX.WEBSITE_SETTINGS.COUNTRY === "JP" ) {
       price = price.replace( /\.[0-9]{2}\b/, "" );
     }


     if (currencySymbolRight){
      html += `<span class="price">${ price }${ currencySymbol }</span>`;

     }else{
      html += `<span class="price">${ currency }${ currencySymbol }${ price }</span>`;
     }

   
     html += F20.returnStarRating( product.rating.value[0], product.review_count.value[0] );
   
     html += `<div><a class="product-button SLB-product-button" href="${ productUrl }" title="${ product.name.value[0] }" data-english="${ product.name.value[0] }">${ productDetailsTxt }</a></div>`;
   
     html += "</div>";
   
   
     html += "</div></div>";
     } else {
     console.log( `No product for ID:${ productId}` );
     }


    });
   
   
    html += "</div>";
   
    if ( showCloseButton ) {
     html += "<button title=\"Close (Esc)\" type=\"button\" class=\"mfp-close\"><span class=\"ico-close\"></span></button>";
    }
   
    html += "</div>";// Transition container
    html += "</div>";
   
    return html;
  };
 
  F20.returnStarRating = function (rating, ratingCount) {

   let maxStars = 5,
    numStars = 0,
    count = 0,
    counts = rating.toString().split("."),
    wholeCount = parseInt(counts[0]),
    partial = parseFloat("0." + counts[1]),
    percent = partial * 100,
    markup = [];
   //
   for (var i = 0; i < wholeCount; i++) {
    numStars++;
    count++;
    markup += '<span class="star red">★</span>';
   }
   //
   if (percent > 0) {
    var partialStyle = 'width:' + percent + '%';
    numStars++;
    count++;
    markup += '<span class="star partial"><span class="background">★</span><span class="highlight" style=' + partialStyle + '>★</span></span>';
   }
   //
   if (numStars !== maxStars) {
    for (var i = 0; i < (maxStars - numStars); i++) {
    count++;
    markup += '<span class="star gray">★</span>';
    }
   }
  
   return '<span class="ratings"><span class="star-display"><span class="stars">' + markup + '</span></span><span class="count">(' + ratingCount + ')</span></span>';
  };




  $( document ).ready( () => {

 //F20.setupProductModal();

  } );

}( jQuery ) );